import React, { useState } from "react";
import styles from "./Row.module.sass";
import moment from "moment";
import cn from "classnames";
import Icon from "../../../../../components/Icon";
import { Tooltip } from "antd";
const Row = ({ data }) => {
  const [tooltipText, setTooltipText] = useState("Copy");

  const formatDate = (date) => {
    const now = moment();
    const createdAt = moment(date);
    const timeStr = createdAt.format("h:mm A");
    if (createdAt.isSame(now, "day")) {
      return `Today at ${timeStr}`;
    } else if (createdAt.isSame(now.subtract(1, "day"), "day")) {
      return `Yesterday at ${timeStr}`;
    } else {
      return `${createdAt.format("DD MMM YYYY")} at ${timeStr}`;
    }
  };

  const copyOrderIdToClipboard = async () => {
    try {
      await navigator.clipboard.writeText(data.order.name);
      setTooltipText("Copied!");
      setTimeout(() => setTooltipText("Copy"), 2000);
      return true;
    } catch (err) {
      console.error("Failed to copy order ID:", err);
      return false;
    }
  };

  return (
    <div className={styles.row}>
      <div className={cn(styles.col)}>
        <div className="flex items-center">
          <span>{data.order.name}</span>
          <div className={styles.copy_icon} onClick={copyOrderIdToClipboard}>
            <Tooltip
              placement="right"
              title={tooltipText}
              overlayClassName="fixed-tooltip"
              getPopupContainer={() =>
                document.querySelector(".fixed-tooltip-container")
              }
            >
              <div className={styles.iconWrapper}>
                <Icon name="copy_to_clipboard" size="26" fill="#9ca3af" />
              </div>
            </Tooltip>
          </div>
        </div>
      </div>
      <div className={`whitespace-nowrap ${styles.col}`}>
        {formatDate(data.created_at)}
      </div>
    </div>
  );
};

export default Row;
